/**
 * ChatPositionManager - Manages chat window positioning based on UI state
 *
 * This module handles automatic repositioning of the chat window when other UI elements
 * like the bio panel are opened or closed to prevent overlapping.
 */

export class ChatPositionManager {
    constructor() {
        this.chatContainer = null;
        this.bioPanel = null;
        this.observer = null;

        // Initialize after DOM is ready
        if (document.readyState === "loading") {
            document.addEventListener("DOMContentLoaded", () =>
                this.initialize(),
            );
        } else {
            this.initialize();
        }
    }

    initialize() {
        // Get references to key elements
        this.chatContainer = document.querySelector(".chat-container");
        this.bioPanel = document.querySelector(".bio-panel");

        if (!this.chatContainer) {
            console.warn("ChatPositionManager: Chat container not found");
            return;
        }

        if (!this.bioPanel) {
            console.warn("ChatPositionManager: Bio panel not found");
            return;
        }

        // Set up observer to watch for bio panel state changes
        this.setupBioPanelObserver();

        console.log("ChatPositionManager: Initialized successfully");
    }

    /**
     * Set up MutationObserver to watch for bio panel class changes
     */
    setupBioPanelObserver() {
        // Create observer to watch for class changes on bio panel
        this.observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (
                    mutation.type === "attributes" &&
                    mutation.attributeName === "class"
                ) {
                    this.handleBioPanelStateChange();
                }
            });
        });

        // Start observing the bio panel for class changes
        this.observer.observe(this.bioPanel, {
            attributes: true,
            attributeFilter: ["class"],
        });

        // Also check initial state
        this.handleBioPanelStateChange();
    }

    /**
     * Handle bio panel state changes
     */
    handleBioPanelStateChange() {
        const isBioPanelActive = this.bioPanel.classList.contains("active");

        if (isBioPanelActive) {
            this.moveChatToLeft();
        } else {
            this.moveChatToDefault();
        }
    }

    /**
     * Move chat window to the left when bio panel is open
     */
    moveChatToLeft() {
        /*if (this.chatContainer) {
            this.chatContainer.classList.add('bio-panel-active');
            console.log('ChatPositionManager: Moved chat window to left position');
        }*/
        console.log("ChatPositionManager: Moved chat window to left position");
    }

    /**
     * Move chat window back to default position when bio panel is closed
     */
    moveChatToDefault() {
        if (this.chatContainer) {
            this.chatContainer.classList.remove("bio-panel-active");
            console.log(
                "ChatPositionManager: Returned chat window to default position",
            );
        }
    }

    /**
     * Manually trigger position update (for external use)
     */
    updatePosition() {
        this.handleBioPanelStateChange();
    }

    /**
     * Clean up observer when no longer needed
     */
    destroy() {
        if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
        }
        console.log("ChatPositionManager: Destroyed");
    }
}
